export default {
  title: {
    id: 'product_jp_product_tab_navigation_title',
    defaultMessage: 'Navigation',
  },
  overview: {
    id: 'product_jp_product_tab_navigation_overview',
    defaultMessage: 'Overview',
  },
  productFeature: {
    id: 'product_jp_product_tab_navigation_product_feature',
    defaultMessage: 'Product Feature',
  },
  reviews: {
    id: 'product_jp_product_tab_navigation_reviews',
    defaultMessage: 'Reviews',
  },
  warranty: {
    id: 'product_jp_product_tab_navigation_warranty',
    defaultMessage: 'Warranty',
  },
  about: {
    id: 'product_jp_product_tab_navigation_about',
    defaultMessage: 'About Back Market',
  },
}
